import { Controller } from "@hotwired/stimulus"

// Filter-cascade behaviour for the Traffic Light Report -- trimmed copy of
// distribution_overview_controller.js (no counts/percentage toggle here,
// the table has no dual count/pct display).
export default class extends Controller {
  static targets = ["filterForm", "validationMessage", "clientHint", "filtersWrapper"]

  filterChanged(event) {
    const changedFilter = event.target.dataset.filterName
    const form = this.filterFormTarget

    if (changedFilter === "client") this.hideValidationError()

    this.clearDependentFilters(changedFilter)

    const formData = new FormData(form)
    const params = new URLSearchParams(formData)
    params.set("changed_filter", changedFilter)

    const url = `/traffic_light_report/filter_options?${params.toString()}`

    fetch(url, {
      headers: {
        "Accept": "text/vnd.turbo-stream.html"
      }
    })
    .then(response => response.text())
    .then(html => {
      Turbo.renderStreamMessage(html)

      if (changedFilter === "client") {
        const hasClient = event.target.value !== ""
        if (this.hasClientHintTarget) this.clientHintTarget.classList.toggle("hidden", hasClient)
        if (this.hasFiltersWrapperTarget) {
          this.filtersWrapperTarget.classList.toggle("opacity-40", !hasClient)
          this.filtersWrapperTarget.classList.toggle("pointer-events-none", !hasClient)
          this.filtersWrapperTarget.classList.toggle("select-none", !hasClient)
        }
      }
    })
  }

  generateReport(event) {
    event.preventDefault()
    const clientSelect = this.filterFormTarget.querySelector('[name="client_id"]')
    if (!clientSelect || !clientSelect.value) {
      this.showValidationError("Please select a client before generating the report.")
      return
    }
    this.hideValidationError()
    event.currentTarget.disabled = true
    this.filterFormTarget.requestSubmit()
  }

  showValidationError(message) {
    if (!this.hasValidationMessageTarget) return
    this.validationMessageTarget.textContent = message
    this.validationMessageTarget.classList.remove("hidden")
  }

  hideValidationError() {
    if (!this.hasValidationMessageTarget) return
    this.validationMessageTarget.classList.add("hidden")
  }

  clearDependentFilters(changedFilter) {
    const hierarchy = {
      "client": ["brand_id", "ph1_id", "ph2_id", "ph3_id", "retailer_id", "banner_id", "place_owner_id[]"],
      "ph1": ["ph2_id", "ph3_id"],
      "ph2": ["ph3_id"],
      "retailer": ["banner_id", "place_owner_id[]"]
    }

    const toClear = hierarchy[changedFilter] || []
    toClear.forEach(fieldName => {
      const field = this.filterFormTarget.querySelector(`[name="${fieldName}"]`)
      if (field) {
        if (field.multiple) {
          Array.from(field.options).forEach(opt => opt.selected = false)
          field.dispatchEvent(new Event("change"))
        } else {
          field.value = ""
        }
      }
    })
  }
}
